import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { toast } from 'react-toastify';
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import moment from "moment"

export default function ItemStockReport() {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState({ category: null, brand: null, item: null });
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchReport = async () => {
        const res = await axios.get('/reports/items-stock', { params: filters });
        setReport(res.data);
    };
    useEffect(() => {
        fetchReport();
    }, [filters]);
    useEffect(() => {
        axios.get('/meta/categories').then(res => {
            const categoriesOption = res.data?.map((item) => {
                return { value: item.id, label: item.name };
            });
            setCategories([{ value: null, label: "All Categories" }, ...categoriesOption])
        });
        axios.get('/meta/brands').then(res => {
            const brandsOption = res.data?.map((item) => {
                return { value: item.id, label: item.name };
            });
            setBrands([{ value: null, label: "All Brands" }, ...brandsOption])
        });
        axios.get('/items').then(res => {
            const itemsOption = res.data?.map((item) => {
                return { value: item.id, label: item.name };
            });
            setItems([{ value: null, label: "All Brands" }, ...itemsOption])
        });
    }, []);

    const capitalizeFirstLetter = (word) => {
        if (!word || typeof word !== "string") return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
    };

    const actions = [
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                navigate(`/expenses/edit/${row.id}`);
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this Expenses?")) {
                    axios.delete(`/expenses/${row.id}`).then((res) => {
                        if (res.data.success === true) {
                            toast.success(res.data.message || "Delete Expenses Successfully")
                            getUnsoledData()
                        }

                    })
                        .catch(err => toast.error(err.message || `Error`));
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/purchases/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        { header: "SKU", accessor: "sku" },
        {
            header: "Item Name", accessor: "item_name",
            render: (value, row) => <span className="text-green-800 font-semibold">{value}</span>
        },
        {
            header: "Brand", accessor: "brand",
            render: (value, row) => <span>{value}</span>
        },
        {
            header: "Category", accessor: "category",
            render: (value, row) => <span>{value}</span>
        },
        {
            header: "Purchases Price", accessor: "latest_purchase_price",
            render: (value, row) => <span>{value}</span>
        },
        {
            header: "Sales Price", accessor: "sales_price",
            render: (value, row) => <span>{value}</span>
        },
        { header: "Purchases Qty", accessor: "purchases_qty" },
        { header: "Sales Qty", accessor: "sales_qty" },
        { header: "Current Qty", accessor: "current_qty" },
        { header: "Total P. Value", accessor: "total_purchase_value" },
        { header: "Total S. Value", accessor: "total_sales_value" },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Items Stock Reports" onDownload={handleDownload} />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div className="flex items-center rounded-md">
                        <Select
                            name="category"
                            onChange={e => setFilters(f => ({ ...f, category: e.value }))}
                            options={categories}
                            placeholder="Select Category"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Select
                            name="brands"
                            onChange={e => setFilters(f => ({ ...f, brand: e.value }))}
                            options={brands}
                            placeholder="Select Brands"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Select
                            name="items"
                            onChange={e => setFilters(f => ({ ...f, item: e.value }))}
                            options={items}
                            placeholder="Select Items"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                </div>
                <ResponsiveTable
                    columns={columns}
                    data={report}
                    showActions={false}
                    actionButtons={actions}
                />
            </div>
        </div>
    );
}